import React from "react";
import {
    Box,
    Grid,
    Typography
} from "@mui/material";

export const CKYCInformationDetails = ({ ckycDetails, currentUser }: any) => {

    if (!ckycDetails || !currentUser) {
        return <div style={{ padding: 20 }}>No CKYC details available.</div>;
    }

    const formatDateTime = (dateStr: any) => {
        if (!dateStr) return "";

        const date = new Date(dateStr);
        const istDate = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
        const day = String(istDate.getDate()).padStart(2, "0");
        const month = String(istDate.getMonth() + 1).padStart(2, "0");
        const year = istDate.getFullYear();
        let hours = istDate.getHours();
        const minutes = String(istDate.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        const hh = String(hours).padStart(2, "0");

        return `${day}-${month}-${year} ${hh}:${minutes} ${ampm}`;
    };

    const getKPI = () => {
        const deadline = ckycDetails?.deadlineDateTime;
        const approvedDate = ckycDetails?.statusApprovedDateTime;
        const internalStatus = ckycDetails?.internalStatus;
        const today = new Date();

        if (!deadline) return "";
        let deadlineDate = new Date(deadline);
        let approvedDateObj = approvedDate ? new Date(approvedDate) : null;
        if (
            internalStatus === "Approved" &&
            approvedDateObj &&
            approvedDateObj <= deadlineDate
        ) {
            return "On Time";
        }
        if (internalStatus === "Pending" && !approvedDateObj) {
            return "In Process";
        }
        if (
            internalStatus === "Approved" &&
            approvedDateObj &&
            approvedDateObj > deadlineDate
        ) {
            return "Delayed";
        }
        if (internalStatus !== "Approved" && today < deadlineDate) {
            return "In Process";
        }

        return "";
    };

    const getDaysLeft = () => {
        const internalStatus = ckycDetails?.internalStatus;
        const deadline = ckycDetails?.deadlineDateTime;

        if (!deadline) return 0;

        if (internalStatus === "Approved") {
            return 0;
        }

        const today = new Date();
        const deadlineDate = new Date(deadline);

        const diffTime = deadlineDate.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays > 0 ? diffDays : 0;
    };


    const getDaysOversight = () => {
        const internalStatus = ckycDetails?.internalStatus;
        const deadline = ckycDetails?.deadlineDateTime;

        if (!deadline) return 0;

        if (internalStatus === "Approved") {
            return 0;
        }

        const today = new Date();
        const deadlineDate = new Date(deadline);

        const diffTime = today.getTime() - deadlineDate.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        return diffDays > 0 ? diffDays : 0;
    };

    const rows = [
        { label: "cKYC Number", value: ckycDetails?.ckycNumber },
        { label: "SMEST KYC Approved on", value: formatDateTime(currentUser?.kyc_markedcompleted_at) },
        { label: "cKYC Deadline Date", value: formatDateTime(ckycDetails?.deadlineDateTime) },
        { label: "cKYC Action", value: ckycDetails?.action_log?.status || "" },
        { label: "cKYC Action By", value: ckycDetails?.action_log?.name || "" },
        {
            label: "State Action Required",
            value: (
                <span
                    style={{
                        color:
                            ckycDetails?.state_action_log?.status === "State Action"
                                ? "red"
                                : "green",
                    }}
                >
                    {ckycDetails?.state_action_log?.status === "State Action"
                        ? "Yes"
                        : "No"}
                </span>
            ),
        },
        {
            label: "Duplications Found",
            value: ckycDetails?.duplicates
                ? ckycDetails.duplicates === "Duplication Found"
                    ? <span style={{ color: "red" }}>Yes</span>
                    : ckycDetails.duplicates === "No Duplicate cKYC"
                        ? <span style={{ color: "green" }}>No</span>
                        : ""
                : ""
        },
        {
            label: "cKYC Status",
            value: ckycDetails?.internalStatus,
            color:
                ckycDetails?.internalStatus === "Pending"
                    ? "orange"
                    : ckycDetails?.internalStatus === "Approved"
                        ? "green"
                        : "red",
        },
        {
            label: "KPI",
            value: (
                <span
                    style={{
                        color:
                            getKPI() === "On Time"
                                ? "green"
                                : getKPI() === "In Process"
                                    ? "orange"
                                    : getKPI() === "Delayed"
                                        ? "red"
                                        : "",
                    }}
                >
                    {getKPI()}
                </span>
            ),
        },
        {
            label: "Days left",
            value: (
                <span style={{ color: getDaysLeft() > 0 ? "green" : "black" }}>
                    {getDaysLeft()}
                </span>
            ),
        },
        {
            label: "Days oversight",
            value: (
                <span style={{ color: getDaysOversight() > 0 ? "red" : "black" }}>
                    {getDaysOversight()}
                </span>
            ),
        },
    ];

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "70%",
                pr: 10,
            }}
        >
            <Grid container spacing={2} sx={{ width: "800px" }}>
                {rows.map((row, index) => (
                    <React.Fragment key={index}>
                        <Grid item xs={6}>
                            <Typography>{row.label}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography
                                sx={{
                                    fontWeight: 500,
                                    color: row.color || "black",
                                }}
                            >
                                {row.value ?? ""}
                            </Typography>
                        </Grid>
                    </React.Fragment>
                ))}
            </Grid>
        </Box>
    );

};